import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  ChatAILeaseRenewalSettings,
  ChatAILeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';

const baseUrl = `${envConfig.service.settings}/company-portal/settings/chataileaserenewal`;

export class AiLeaseRenewalSettingsRepository extends BaseRestRepository {
  public async getAllAiLeaseRenewalSettings(): Promise<ChatAILeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = baseUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAiLeaseRenewalSettingsByLevel(level: string, levelId: string): Promise<ChatAILeaseRenewalSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateAiLeaseRenewalSettings(payload: ChatAILeaseRenewalSettings): Promise<ChatAILeaseRenewalSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async updateAiLeaseRenewalSettingsByLevel(
    level: string,
    levelId: string,
    payload: ChatAILeaseRenewalSettings
  ): Promise<ChatAILeaseRenewalSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteAiLeaseRenewalSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
